// ==========================================================================
// FILE: /app/components/onboarding/WelcomeStep.tsx
// ==========================================================================
import { type FC } from "react";
import GxButton from "@/app/components/common/actions/buttons/GxButton";
import BaseModal from "@/app/page/default/admin-menu/managebankaccounts/BaseModal";
import { ICON_BASE_PATH } from "@/app/utils/config";

interface WelcomeStepProps {
  isOpen: boolean;
  onStart: () => void;
  onSkip: () => void;
}

const WelcomeStep: FC<WelcomeStepProps> = ({ isOpen, onStart, onSkip }) => (
  <BaseModal isOpen={isOpen} onClose={onSkip}>
    <div className="flex flex-col items-center text-center my-5">
      <h2 className="gx-h2-b mt-2 flex gap-1.5">
        Welcome to{" "}
        <span>
          {" "}
          <img
            src={`${ICON_BASE_PATH}logo-growx.svg`}
            alt="Logo"
            className="object-contain mt-2"
            height={100}
            width={115}
          />
        </span>
      </h2>
      <p className="gx-p14-sb mt-1">Let's get your workspace ready.</p>
      <p className="gx-p14-r text-gray-600 mt-4 leading-relaxed">
        Before you begin, we'll guide you through a few quick setup steps to
        configure your company account. This will only take a few minutes and
        helps ensure everything is ready for your team.
      </p>
      <p className="gx-p14-sb mt-4">
        Would you like to complete the initial setup now?
      </p>
      <div className="flex items-center gap-4 mt-6 w-full">
        <GxButton
          variant="outlined"
          bgColor="#666666"
          width="custom"
          customWidth="8rem"
          height="medium"
          onClick={onSkip}
        >
          Skip for Now
        </GxButton>
        <GxButton
          variant="filled"
          bgColor="#000000"
          textColor="#ffffff"
          width="custom"
          customWidth="8rem"
          height="medium"
          onClick={onStart}
          className="ml-auto"
        >
          Start Setup
        </GxButton>
      </div>
      <p className="gx-p12-sb text-gray-400 mt-4">
        You can complete the setup later from Settings.
      </p>
    </div>
  </BaseModal>
);

export default WelcomeStep;
